import React from "react";
import { useRef, useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";
import useResizeObserver from "@react-hook/resize-observer";
import "./_styles.scss";
import { classNameBuilder } from "../../utilities";

interface ScrollableProps {
  className?: string;
  children?: React.ReactNode;
}

export default function Scrollable({ className, children }: ScrollableProps) {
  const scrollableRef = useRef<Scrollbars>(null);
  const [content, setContent] = useState<HTMLDivElement | null>(null);

  useResizeObserver(content, () => {
    const scrollable: Scrollbars | null = scrollableRef.current;

    if (!scrollable) return;

    const scrollTop = scrollable.getScrollTop();

    scrollable.scrollToBottom();
    scrollable.scrollTop(scrollTop);
  });

  return (
    <Scrollbars
      className={classNameBuilder("h-app-scrollable", className ?? "")}
      ref={scrollableRef}
    >
      <div className="h-app-scrollable-content" ref={(c) => setContent(c)}>
        {children}
      </div>
    </Scrollbars>
  );
}
